"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInfo = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// @ts-ignore: missing type definition
const react_native_1 = require("react-native");
const Logger_1 = require("../../Logger");
const logger = new Logger_1.ConsoleLogger('getClientInfo');
const getClientInfo = () => {
    const dim = react_native_1.Dimensions.get('screen');
    logger.debug(react_native_1.Platform, dim);
    const OS = 'android';
    const { Version } = react_native_1.Platform;
    return {
        platform: OS,
        version: String(Version),
        appVersion: [OS, String(Version)].join('/'),
    };
};
exports.getClientInfo = getClientInfo;
